module.exports = __webpack_public_path__ + "static/media/wesley.06ea3aa3.jpeg";